export default "__VITE_ASSET__DZup7yhK__"